/**
 * Downloads a blob as a file
 */
export function downloadBlobAsFile(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

/**
 * Opens a blob in a new window/tab
 */
export function openBlobInNewTab(blob: Blob): void {
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener,noreferrer');
  // Clean up the URL after a delay to allow the browser to open it
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 100);
}

